import React from "react";
import { array, bool, string } from "prop-types";
import { Link } from "@quintype/components";

import NewsHeadline from "../../atoms/NewsHeadline";

import { staticTexts } from "../../utils/Translate";

import "./numberedStoryHeadline.m.css";

const NumberedStoryHeadline = ({ storyList, className = "", lang, numberShow = true }) => {
  return (
    <div className="numbered-story-headline-wrapper">
      {storyList.map(({ story }, index) => (
        <Link aria-label={story.headline} href={story.url} key={index} styleName="wrapper" className={className}>
          <div styleName="content" className="content numbered-story-headline">
            {numberShow && (
              <span styleName="number" className="headline-number">
                {staticTexts(lang).NUMBER_ARRAY[index + 1]}
              </span>
            )}
            <NewsHeadline story={story} cssStyleName="smallSize" linkEnable={false} />
          </div>
        </Link>
      ))}
    </div>
  );
};

NumberedStoryHeadline.propTypes = {
  className: string,
  storyList: array,
  lang: string,
  numberShow: bool,
};

export default NumberedStoryHeadline;
